import { GET_SCHEDULES_ID, MY_CALENDAR_DATA } from '@queries/index'
import { keyBy, merge, values } from 'lodash'
import React from 'react'
import { adopt } from 'react-adopt'
import { Query } from 'react-apollo'
import { SessionInfo } from '../ScheduleListCard/interface'

interface QueryPageResults {
  loading: boolean
  data: any
}

interface QueryMyCalendarProps {
  Id: string
  FromDate: string
  EndDate: string
  FilterType: string
  Limit: number
  UserId: string
  children: (results: QueryPageResults) => {}
}

const QueryMyCalendar: React.FC<QueryMyCalendarProps> = ({ Id, FromDate, EndDate, FilterType, Limit, UserId, children }) => {
  const Composed = adopt({
    myCalendarQuery: ({ render }) => (
      <Query
        query={MY_CALENDAR_DATA}
        variables={{
          Id,
          FromDate,
          EndDate,
          FilterType,
          Limit,
          UserId
        }}
        fetchPolicy="no-cache"
      >
        {render}
      </Query>
    ),
    lessonHistoryQuery: ({ render }) => (
      <Query
        query={GET_SCHEDULES_ID}
        variables={{
          Id,
          FromDate,
          EndDate,
          FilterType: 'FILTER_LESSON_HISTORY',
          Limit,
          UserId
        }}
        fetchPolicy="no-cache"
      >
        {render}
      </Query>
    ),
  })

  return (
    <Composed>
      {({ myCalendarQuery, lessonHistoryQuery }) => {
        if (myCalendarQuery.loading || lessonHistoryQuery.loading) {
          return children({ loading: true, data: [] })
        }
        const queryResult = values(
          merge(keyBy(lessonHistoryQuery.data?.getSchedulesId, 'Id'), keyBy(myCalendarQuery.data?.getSchedulesId, 'Id'))
        ) as SessionInfo[]

        const sessions: SessionInfo[] = queryResult ? queryResult.filter(({ Status }) => Status !== 'Cancelled') : []

        return children({
          loading: false,
          data: sessions,
        })
      }}
    </Composed>
  )
}

export default QueryMyCalendar
